import { apiRequest, clearGetCache } from './api';

const WISHLISTS_ENDPOINT = '/api/profile/wishlists';

function getAuthHeaders() {
  try {
    const token = window.localStorage.getItem('chse_auth_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

export async function getWishlists() {
  return apiRequest(WISHLISTS_ENDPOINT, {
    method: 'GET',
    headers: getAuthHeaders(),
  });
}

export async function addWishlistItem(courseId) {
  const result = await apiRequest(WISHLISTS_ENDPOINT, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify({ course_id: courseId }),
  });
  clearGetCache(WISHLISTS_ENDPOINT);
  return result;
}

export async function removeWishlistItem(wishlistId) {
  const result = await apiRequest(`/api/profile/wishlists/${wishlistId}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });
  clearGetCache(WISHLISTS_ENDPOINT);
  return result;
}

export async function removeWishlistByCourseId(courseId) {
  const result = await apiRequest(`/api/profile/wishlists/remove_by_course/${courseId}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });
  clearGetCache(WISHLISTS_ENDPOINT);
  return result;
}
